import React from "react";

const QurbaniData = () => {
  return (
    <div className="container">
      <h2 className="py-3">কুরবানীর সংক্রান্ত কিছু তথ্য</h2>
      <h4 className="py-2">কুরবানীর গুরুত্ব</h4>
      <div className="pra">
        <p>
          কুরবানী হলো ইসলামের একটি শি’য়ার বা মহান নিদর্শন। কুরআন মাজীদে আল্লাহ
          তা‘আলা নির্দেশ দিয়েছেন: ﴿ فَصَلِّ لِرَبِّكَ وَٱنۡحَرۡ ٢ ﴾ [الكوثر: ٢]
          ‘তোমার প্রতিপালকের উদ্দেশ্যে সালাত আদায় কর ও পশু কুরবানী কর।’ [সূরা
          আল-কাউসার : ২] আবু হুরায়রা রাদিয়াল্লাহু ‘আনহু থেকে বর্ণিত, রাসূলুল্লাহ
          সাল্লাল্লাহু আলাইহি ওয়াসাল্লাম বলেছেন : «مَنْ وَجَدَ سَعَةً فَلَمْ
          يُضَحِّ فَلَا يَقْرَبَنَّ مُصَلَّانَا» ‘যে ব্যক্তি সামর্থ্য থাকা
          সত্ত্বেও কুরবানি করে না সে যেন আমাদের ঈদগাহের ধারে না আসে। [মুসনাদ
          আহমাদ, ইবন মাজাহ- ৩১২৩ হাদীসটি হাসান] যারা কুরবানী পরিত্যাগ করে তাদের
          প্রতি এ হাদীস একটি সতর্কবাণী। অনুরূপভাবে রাসূল সাল্লাল্লাহু আলাইহি
          ওয়াসাল্লাম কুরবানী করার নির্দেশ দিয়ে বলেন, «يَا أَيُّهَا النَّاسُ
          عَلَى كُلِّ أَهْلِ بَيْتٍ فِي كُلِّ عَامٍ أُضْحِيَّة» “হে লোক সকল,
          প্রত্যেক পরিবারের উপর কুরবানী দেয়া অপরিহার্য।” [সুনান ইবন মাজাহ-৩১২৫,
          হাদীসটি হাসান]। উল্লেখিত আলোচনা থেকে প্রমাণিত হয় যে, কুরবানী করা
          ওয়াজিব। তবে অনেক ওলামায়ে কিরাম কুরবানী করা সুন্নাতে মুয়াক্কাদাহ
          বলেছেন।
        </p>
      </div>
      <h4 className="py-2">কুরবানীর উদ্দেশ্য</h4>
      <div className="pra">
        <p>
          কুরবানী একটি গুরুত্বপূর্ণ ইবাদত। আল্লাহ রাব্বুল আলামিন মানব জাতিকে
          সৃষ্টি করেছেন শুধু তার ইবাদত করার জন্য। তাই আল্লাহ তা‘আলার বিধান তাঁর
          নির্দেশিত পথে পালন করতে হবে। তিনি বলেন : ﴿ وَمَا خَلَقۡتُ ٱلۡجِنَّ
          وَٱلۡإِنسَ إِلَّا لِيَعۡبُدُونِ ٥٦ ﴾ [الذاريات: ٥٦] ‘আমি জিন ও মানুষকে
          এ জন্য সৃষ্টি করেছি যে, তারা শুধু আমার ইবাদত করবে।’ [সূরা
          আয্যারিয়াত-৫৬] আল্লাহ তা‘আলার পক্ষ থেকে কুরবানীর বিধান আমাদের উপর আসার
          বেশ কিছূ উদ্দেশ্যও রয়েছে:
        </p>
        <h5>১. শর্তহীন আনুগত্য</h5>
        <p>
          আল্লাহ তা‘আলা তার বান্দাহকে যে কোনোআদেশ দেয়ার ইখতিয়ার রাখেন এবং
          বান্দাহ তা পালন করতে বাধ্য। তাই তার আনুগত্য হবে শর্তহীন। আল্লাহর আদেশ
          সহজ হোক আর কঠিন হোক তা পালন করার বিষয়ে একই মন-মানসিকতা থাকতে হবে এবং
          আল্লাহর হুকুম মানার বিষয়ে মায়া-মমতা প্রতিবন্ধক হতে পারে না। ইবরাহীম
          আলাইহিস সালাম এর আনুগত্য ছিল শর্তহীন। এ জন্য মহান আল্লাহ যেভাবে বিশ্ব
          মানবমন্ডলীকে বিভিন্ন জাতিতে বিভক্ত করেছেন ঠিক সেভাবে সর্বশেষ জাতি
          হিসেবে মুসলিম জাতির পিতাও মনোনয়ন দিয়েছেন । কুরআনে এসেছে : ﴿مِّلَّةَ
          أَبِيكُمۡ إِبۡرَٰهِيمَۚ هُوَ سَمَّىٰكُمُ ٱلۡمُسۡلِمِينَ﴾ [الحج: ٧٨]
          ‘এটা তোমাদের পিতা ইবরাহীমের মিল্লাত;তিনি পূর্বে তোমাদের নামকরণ করেছেন
          মুসলিম।’ [সূরা আল–হাজ্জ : ৭৮]
        </p>
        <h5>২. তাকওয়া অর্জন</h5>
        <p>
          তাকওয়া অর্জন ছাড়া আল্লাহর নৈকট্য লাভ করা যায় না। একজন মুসলিমের অন্যতম
          চাওয়া হলো আল্লাহ তা‘আলার নৈকট্য অর্জন। পশুর রক্ত প্রবাহিত করার মাধ্যমে
          কুরবানী দাতা আল্লাহ রাব্বুল আলামিনের নৈকট্য অর্জন করেন। যেমন আল্লাহ
          তা‘আলা বলেন : ﴿ لَن يَنَالَ ٱللَّهَ لُحُومُهَا وَلَا دِمَآؤُهَا
          وَلَٰكِن يَنَالُهُ ٱلتَّقۡوَىٰ مِنكُمۡۚ كَذَٰلِكَ سَخَّرَهَا لَكُمۡ
          لِتُكَبِّرُواْ ٱللَّهَ عَلَىٰ مَا هَدَىٰكُمۡۗ وَبَشِّرِ ٱلۡمُحۡسِنِينَ
          ٣٧ ﴾ [الحج: ٣٧] ‘আল্লাহর নিকট পৌঁছায় না তাদের গোশত এবং রক্ত, বরং
          পৌঁছায় তোমাদের তাকওয়া। এভাবে তিনি এগুলোকে তোমাদের অধীন করে দিয়েছেন
          যাতে তোমরা আল্লাহর শ্রেষ্ঠত্ব ঘোষণা কর এজন্য যে, তিনি তোমাদের
          পথ-প্রদর্শন করেছেন; সুতরাং আপনি সুসংবাদ দিন সৎকর্মপরায়ণদেরকে। [সূরা
          আল-হাজ্জ: ৩৭]
        </p>
        <h5>৩. আল্লাহর শ্রেষ্ঠত্ব ঘোষণা করা</h5>
        <p>
          প্রত্যেক ইবাদাতই আল্লাহর শ্রেষ্ঠত্বের প্রমাণ বহন করে। তাই কুরবানীর
          মাধ্যমে আল্লাহর শ্রেষ্ঠত্ব ঘোষণা করা হয়। যেমন আল্লাহ তা‘আলা বলেন :
          ﴿كَذَٰلِكَ سَخَّرَهَا لَكُمۡ لِتُكَبِّرُواْ ٱللَّهَ عَلَىٰ مَا
          هَدَىٰكُمۡۗ وَبَشِّرِ ٱلۡمُحۡسِنِينَ ٣٧ ﴾ [الحج: ٣٧] ‘এভাবে তিনি
          এগুলোকে তোমাদের অধীন করে দিয়েছেন যাতে তোমরা আল্লাহর শ্রেষ্ঠত্ব ঘোষণা
          কর এজন্য যে, তিনি তোমাদের পথ-প্রদর্শন করেছেন; সুতরাং আপনি সুসংবাদ দিন
          সৎকর্মপরায়ণদেরকে। [সূরা আল-হাজ্জ: ৩৭]
        </p>
        <h5>৪. ত্যাগ করার মহান পরীক্ষা</h5>
        <p>
          কুরবানীর অন্যতম উদ্দেশ্য হলো ত্যাগ করার মানসিকতা তৈরী করা। আল্লাহর
          বিধান পালনে জান-মালের ত্যাগ স্বীকার করতে হবে। কুরবানীর ঈদকে গোশত
          খাওয়ার অনুষ্ঠানে পরিণত করা নয়, বরং নিজেদের মধ্যকার পশুসুলভ আচরণ ত্যাগ
          করার জন্য প্রস্তুত থাকতে হবে। নফসের আনুগত্য ত্যাগ করে আল্লাহর একান্ত
          অনুগত হওয়াই কুরবানীর উদ্দেশ্য। ﴿ وَلَنَبۡلُوَنَّكُم بِشَيۡءٖ مِّنَ
          ٱلۡخَوۡفِ وَٱلۡجُوعِ وَنَقۡصٖ مِّنَ ٱلۡأَمۡوَٰلِ وَٱلۡأَنفُسِ
          وَٱلثَّمَرَٰتِۗ وَبَشِّرِ ٱلصَّٰبِرِينَ ١٥٥ ﴾ [البقرة: ١٥٥] ‘আমি
          তোমাদেরকে অবশ্যই ভয়, দারিদ্র্য, সম্পদ ও জীবনের ক্ষয়ক্ষতি করার মাধ্যমে
          পরীক্ষা করবো।’ [সূরা আল-বাকারাহ: ১৫৫]
        </p>
      </div>
      <h4 className="py-2">কুরবানীর ফযিলাত</h4>
      <div className="pra">
        <p>
          ১. কুরবানীদাতা কুরবানীর পশুর জবাই এর মাধ্যমে ইবরাহীম আলাইহিস সালাম ও
          শেষ নবী সাল্লাল্লাহু আলাইহি ওয়াসাল্লামের সুন্নাতের বাস্তবায়ন করতে
          পারে। আল-কুরআনে আল্লাহ তা‘আলা বলেন : ﴿ وَفَدَيۡنَٰهُ بِذِبۡحٍ عَظِيمٖ
          ١٠٧ ﴾ [الصافات: ١٠٧] ‘আর আমরা মহা কুরবানীর বিনিময়ে তাকে মুক্ত করেছি।”
          [সূরা আস-সাফফাত: ১০৭] এ আয়াতের তাফসীরে তাফসীর বিশারদগণ উল্লেখ করেছেন,
          সকল কুরবানী এ মহাকুরবানীর অন্তর্ভুক্ত। এ জন্য রাসূল সাল্লাল্লাহু
          আলাইহি ওয়াসাল্লাম যায়েদ ইবনে আরকাম বর্ণিত হাদীসেও কুরবানীকে ইবরাহীম
          আলাইহিস সালাম এর সুন্নাত হিসাবে উল্লেখ করেছেন।
        </p>
        <p>
          ২. কুরবানীর রক্ত প্রবাহিত করার মাধ্যমে আল্লাহ রাব্বুল আলামীনের নৈকট্য
          অর্জিত হয়। আল্লাহ তা‘আলা বলেন- ﴿ لَن يَنَالَ ٱللَّهَ لُحُومُهَا وَلَا
          دِمَآؤُهَا وَلَٰكِن يَنَالُهُ ٱلتَّقۡوَىٰ مِنكُمۡۚ كَذَٰلِكَ
          سَخَّرَهَا لَكُمۡ لِتُكَبِّرُواْ ٱللَّهَ عَلَىٰ مَا هَدَىٰكُمۡۗ
          وَبَشِّرِ ٱلۡمُحۡسِنِينَ ٣٧ ﴾ [الحج: ٣٧] “আল্লাহর নিকট পৌঁছায় না
          তাদের গোশত এবং রক্ত,পৌঁছায় তোমাদের তাকওয়া। এভাবে তিনি এগুলোকে তোমাদের
          অধীন করে দিয়েছেন যাতে তোমরা আল্লাহর শ্রেষ্ঠত্ব ঘোষণা কর এজন্য যে, তিনি
          তোমাদের পথ-প্রদর্শন করেছেন। সুতরাং আপনি সুসংবাদ দিন সৎকর্ম
          পরায়ণদেরকে।” [সূরা আল-হাজ্জ: ৩৭]
        </p>
        <p>
          ৩. কুরবানী আল্লাহ তা‘আলার অন্যতম নিদর্শন। সূরা হজ্জের ৩৬ নং আয়াতে
          আল্লাহ বলেন- ﴿ وَٱلۡبُدۡنَ جَعَلۡنَٰهَا لَكُم مِّن شَعَٰٓئِرِ ٱللَّهِ
          لَكُمۡ فِيهَا خَيۡرٞۖ فَٱذۡكُرُواْ ٱسۡمَ ٱللَّهِ عَلَيۡهَا صَوَآفَّۖ
          فَإِذَا وَجَبَتۡ جُنُوبُهَا فَكُلُواْ مِنۡهَا وَأَطۡعِمُواْ ٱلۡقَانِعَ
          وَٱلۡمُعۡتَرَّۚ كَذَٰلِكَ سَخَّرۡنَٰهَا لَكُمۡ لَعَلَّكُمۡ تَشۡكُرُونَ
          ٣٦ ﴾ [الحج: ٣٦] “কুরবানীর উটসমূহকে আমরা তোমাদের জন্য আল্লাহর নিদর্শনের
          অন্যতম করেছি। তোমাদের জন্য যাতে কল্যাণ রয়েছে। সুতরাং সারিবদ্ধভাবে
          দন্ডায়মান অবস্থা এগুলোর উপর তোমরা আল্লাহর নাম স্মরণ করো আর যখন কাত হয়ে
          পড়ে যায় তখন সেগুলো হতে খাও। আর আহার করাও ধৈর্য্যশীল অভাবী ও ভিক্ষাকারী
          অভাবগ্রস্তকে এভাবে আমি ওদেরকে তোমাদের অধীন করে দিয়েছি, যাতে তোমরা
          কৃতজ্ঞতা প্রকাশ কর।”এ আয়াতে কুরবানীর ফযিলত সুস্পষ্টভাবে তুলে ধরা হয়েছে
          এবং কুরবানীর পশুকে আল্লাহর অন্যতম নিদর্শন হিসেবে তুলে ধরা হয়েছে।
        </p>
        <p>
          ৪. পশু দ্বারা কুরবানীর মাধ্যমে আল্লাহর যিকির বা স্মরণের বাস্তবায়ন করে
          থাকেন। এ প্রসঙ্গে পবিত্র কুরআনে ইরশাদ হয়েছে : ﴿ وَلِكُلِّ أُمَّةٖ
          جَعَلۡنَا مَنسَكٗا لِّيَذۡكُرُواْ ٱسۡمَ ٱللَّهِ عَلَىٰ مَا رَزَقَهُم
          مِّنۢ بَهِيمَةِ ٱلۡأَنۡعَٰمِۗ ﴾ [الحج: ٣٤] ‘আমি প্রত্যেক সম্প্রদায়ের
          জন্য কুরবানীর নিয়ম করে দিয়েছি; তিনি তাদেরকে জীবনোপকরণ স্বরূপ যে সকল
          চতুষ্পদ জন্তু দিয়েছেন, সেগুলোর উপর যেন তারা আল্লাহর নাম স্মরণ করে।
          [সূরা আল-হাজ্জ: ৩৪]
        </p>
        <p>
          ৫. কুরবানীর প্রবাহিত রক্ত আল্লাহ তা‘আলার কাছে দু’টি কুচকুচে কালো
          ছাগলের চেয়ে প্রিয় ও পবিত্র। এ প্রসঙ্গে রাসূলুল্লাহ সাল্লাল্লাহু আলাইহি
          ওয়াসাল্লাম হতে আবু হুরায়রা রাদিয়াল্লাহু আনহু বর্ণনা করেন, রাসূলুল্লাহ
          সাল্লাল্লাহু আলাইহি ওয়াসাল্লাম বলেছেন, «دَمُ عَفْرَاءَ أَحَبُّ إلى
          الله مِنْ دَمِ سَوْدَاوَيْنِ». অর্থাৎ কুরবানীর প্রবাহিত রক্ত আল্লাহ
          তা‘আলার কাছে দু’টি কুচকুঁচে কালো ছাগলের চেয়ে অধিক প্রিয়। [সুনান
          বায়হাকী ]
        </p>
        <p>
          ৬. ইসলামে হাজ্জ একটি গুরুত্বপূর্ণ মৌলিক ইবাদত। হজ্জের সাথে কুরবানীর
          অনেক বিষয় জড়িত। হাজীগণ এ দিনে তাদের পশু যবেহ করে হজ্জকে পূর্ণ করেন। এ
          জন্য এর নাম হল (يَوْمُ الْحَجِّ الْأَكْبَرِ) বা শ্রেষ্ঠ হজের দিন।
          হাদীসে এসেছে, ইবন উমর রাদিয়াল্লাহু ‘আনহু বলেন, «أَنَّ رَسُولَ اللَّهِ
          صَلَّى اللَّهُ عَلَيْهِ وَسَلَّمَ وَقَفَ يَوْمَ النَّحْرِ بَيْنَ
          الْجَمَرَاتِ فِي الْحَجَّةِ الَّتِي حَجَّ فَقَالَ أَيُّ يَوْمٍ هَذَا
          قَالُوا يَوْمُ النَّحْرِ قَالَ هَذَا يَوْمُ الْحَجِّ الْأَكْبَرِ»
          “রাসূলুল্লাহ সাল্লাল্লাহু আলাইহি ওয়াসাল্লাম কুরবানীর দিন জিজ্ঞেস করলেন
          এটা কোন দিন? সাহাবাগণ উত্তর দিলেন এটা ইয়াওমুন্নাহর বা কুরবানির দিন।
          রাসূলে কারীম সাল্লাল্লাহু আলাইহি ওয়াসাল্লাম বললেন, এটা হলো ইয়াওমুল
          হাজ্জিল আকবার বা শ্রেষ্ঠ হজের দিন। [সুনান আবু দাউদ]
        </p>
        <p>
          ৭. কুরবানীর মাধ্যমে সামাজিক ও পারিবারিক ঐক্য প্রতিষ্ঠা করার বিশেষ
          সুযোগ সৃষ্টি হয়। সমাজে আল্লাহর বিধান প্রতিষ্ঠার জন্য ঐক্যবদ্ধভাবে কাজ
          করার প্রেরণা তৈরি হয়। আল্লাহ তা‘আলা বলেন : ﴿ وَٱعۡتَصِمُواْ بِحَبۡلِ
          ٱللَّهِ جَمِيعٗا وَلَا تَفَرَّقُواْۚ﴾ [ال عمران: ١٠٣] তোমারা আল্লাহর
          রজ্জুকে ঐক্যবদ্ধভাবে আঁকড়ে ধর এবং পরস্পর বিচ্ছিন্ন হয়ো না। [সূরা আলে
          ইমরান : ১০৩]
        </p>
        <p>
          ৮. কুরবানীতে গরীব মানুষের অনেক উপকার হয়। যারা বছরে একবারও গোশত্ খেতে
          পারে না, তারাও গোশত্ খাবার সুযোগ পায়। দারিদ্র বিমোচনেও এর গুরুত্ব
          রয়েছে। কুরবানীর চামড়ার টাকা গরীবের মাঝে বণ্টন করার মাধ্যমে গরীব-দুখী
          মানুষের প্রয়োজন মেটানো সম্ভব। অপরদিকে কুরবানীর চামড়া অর্থনীতিতে একটি
          বিরাট ভূমিকা পালন করে থাকে।
        </p>
      </div>
    </div>
  );
};

export default QurbaniData;
